// extracted by mini-css-extract-plugin
export default {"scrollBtn":"ScrollableContainer_scrollBtn_3awEV"};